import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  isOpenModal: false,
  ownershipFilter: null,
  itemsFilter: [],
}

export const inventoriIntelligentSlice = createAppSlice({
  name: 'inventoriIntelligent',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModal: create.reducer((state, { payload }) => {
      state.isOpenModal = !state.isOpenModal
    }),
    setOwnershipFilter: create.reducer((state, { payload }) => {
      state.ownershipFilter = payload
    }),
    setItemsFilter: create.reducer((state, { payload }) => {
      state.itemsFilter = payload
    }),
    removeItemFilter: create.reducer((state, { payload }) => {
      state.itemsFilter = state.itemsFilter.filter(
        (item) => item.value !== payload,
      )
    }),
  }),
  extraReducers: (builder) => {},
})

export const {
  setFetchOption,
  toggleModal,
  setOwnershipFilter,
  setItemsFilter,
  removeItemFilter,
} = inventoriIntelligentSlice.actions

export default inventoriIntelligentSlice.reducer
